<!--===========================
=            ALERT            =
============================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Alerts</div>
      </base-header>
    </v-row> <v-row>
   

        <v-col cols="12" md="6" sm="12">
          <base-card>
            <div slot="card-header"> #Shaped

            </div>
            <div slot="card-subheader"> The shaped prop will add border-radius at the top-left and bottom-right of the
              alert. Similar to other styled props, shaped can be combined with other props like dense, prominent,
              outlined and text to create a unique and customized component
            </div>
            <div slot="card-body">
              <div>
                <v-alert shaped dark color="info">
                  I'm a shaped alert with a border-radius at top-left, bottom-right
                </v-alert>
                <v-alert shaped outlined type="success">
                  I'm a shaped alert with a outline option
                </v-alert>
                <v-alert shaped dense dark type="warning">
                  I'm a shaped alert with a dense option option
                </v-alert>
                <v-alert shaped prominent type="error">
                  I'm a shaped alert with a dense prominent option that Praesent blandit laoreet nibh. Praesent nonummy
                  mi in odio. Phasellus tempus. Mauris turpis nunc, blandit et, volutpat molestie, porta ut, ligula.
                  Duis leo.
                </v-alert>
              </div>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="6" sm="12">
          <base-card>
            <div slot="card-header"> #Outlined
            </div>
            <div slot="card-subheader">
              The outlined prop inverts the style of an alert, inheriting the currently applied color, applying it to
              the text and border, and making its background transparent.
            </div>
            <div slot="card-body">
              <template>
                <div>
                  <v-alert outlined color="purple">
                    <div class="text-h6">
                      Lorem Ipsum
                    </div>
                    <div>Maecenas ullamcorper, dui et placerat feugiat, eros pede varius nisi, condimentum viverra felis
                      nunc et lorem. Duis vel nibh at velit scelerisque suscipit. Praesent blandit laoreet nibh. Aenean
                      posuere, tortor sed cursus feugiat, .</div>
                  </v-alert>
                  <v-alert outlined type="success" text>
                    Praesent venenatis metus at tortor pulvinar varius.
                  </v-alert>
                  <v-alert outlined type="warning" prominent border="left">
                    Duis arcu tortor, suscipit eget, imperdiet nec,
                  </v-alert>
                </div>
              </template>
            </div>
          </base-card>
        </v-col>

    </v-row>
    <v-row>
      
        <v-col cols="12" md="6" sm="12">
          <base-card>
            <div slot="card-header"> Border

            </div>
            <div slot="card-subheader"> The border prop adds a simple border to one of the 4 sides of the alert. This
              can be combined with props like color, dark, and type to provide unique accents to the alert.
            </div>
            <div slot="card-body">
              <div>
                <v-alert border="top" color="red lighten-2" dark>
                  I'm an alert with a top border and red color
                </v-alert>
                <v-alert border="right" color="blue-grey" dark>
                  I'm an alert with a right border and blue-grey color
                </v-alert>
                <v-alert border="bottom" color="pink darken-1" dark>
                  I'm an alert with a bottom border and pink color
                </v-alert>
                <v-alert border="left" color="indigo" dark>
                  I'm an alert with a border left type info
                </v-alert>
              </div>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="6" sm="12">
          <base-card>
            <div slot="card-header"> #Type

            </div>
            <div slot="card-subheader"> The type prop provides 4 default v-alert styles: success, info, warning, and
              error. Each of these styles provides a default icon and color. The default colors can be configured
              globally by customizing Vuetify’s theme.
            </div>
            <div slot="card-body">
              <div>
                <v-alert type="success">
                  I'm a success alert.
                </v-alert>

                <v-alert type="info">
                  I'm an info alert.
                </v-alert>

                <v-alert type="warning">
                  I'm a warning alert.
                </v-alert>

                <v-alert type="error">
                  I'm an error alert.
                </v-alert>
              </div>
            </div>
          </base-card>
        </v-col>

     
    </v-row>
   


  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },

  }
</script>

<!--====  End of ALERT  ====-->
